<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Учет БСО') }}</h1>
    <div class="my-organization">
      <div class="blanks-pg bgw-pdg-20">
        <div class="search-head">
          <div class="flex-two-col">
            <div class="flex-two-col__left">
              <Menu/>
            </div>
          </div>
          <v-row>
            <v-col cols="12" sm="4" md="4">
              <v-label>{{ $t('Номер') }}</v-label>
              <v-text-field
                v-model="search.number"
                outlined
                dense
                clearable
              />
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-label>{{ $t('Тип') }}</v-label>
              <div class="select-def">
                <v-select
                  :items="refType"
                  item-value="id"
                  item-text="transCorrectName"
                  v-model="search.type"
                  :placeholder="$t('Все')"
                  outlined
                  dense
                  clearable
                />
              </div>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-label>{{ $t('Статус') }}</v-label>
              <div class="select-def">
                <v-select
                  :items="refStatus"
                  item-value="id"
                  item-text="transName"
                  v-model="search.status"
                  :placeholder="$t('Все')"
                  outlined
                  dense
                  clearable
                />
              </div>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-label>{{ $t('Представительство') }}</v-label>
              <div class="select-def">
                <v-select
                  :items="oopts"
                  item-value="id"
                  item-text="transName"
                  v-model="search.oopt"
                  :placeholder="$t('Все')"
                  outlined
                  dense
                  clearable
                />
              </div>
            </v-col>
          </v-row>
          <div class="search-action">
            <button
              class="btn btn-default green-grassy"
              @click="getList()"
            >
              {{ $t('Поиск') }}
            </button>
            <button
              class="btn btn-default gray"
              @click="search = {}, getList()"
            >
              {{ $t('Очистить') }}
            </button>
          </div>
        </div>
        <div class="search-body">
          <div class="table-overflow">
            <table class="table-full">
              <thead>
              <tr>
                <td>
                  <div class="sort-flex">
                    {{ $t('Тип БСО') }}
                    <a @click="sort('type')" class="sort-btn sort-blue">
                      <v-icon v-if="sortParams.field == 'type' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                      <v-icon v-else>arrow_drop_down</v-icon>
                    </a>
                  </div>
                </td>
                <td>
                  <div class="sort-flex">
                    {{ $t('Номер БСО') }}
                    <a @click="sort('number')" class="sort-btn sort-blue">
                      <v-icon v-if="sortParams.field == 'number' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                      <v-icon v-else>arrow_drop_down</v-icon>
                    </a>
                  </div>
                </td>
                <td>
                  <div class="sort-flex">
                    {{ $t('Дата изготовления') }}
                    <a @click="sort('date')" class="sort-btn sort-blue">
                      <v-icon v-if="sortParams.field == 'date' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                      <v-icon v-else>arrow_drop_down</v-icon>
                    </a>
                  </div>
                </td>
                <td>{{ $t('Цена (в сомах)') }}</td>
                <td>
                  <div class="sort-flex">
                    {{ $t('Представительство') }}
                  </div>
                </td>
                <td>
                  <div class="sort-flex">
                    {{ $t('Статус') }}
                    <a @click="sort('status')" class="sort-btn sort-blue">
                      <v-icon v-if="sortParams.field == 'status' && sortParams.order == 'DESC'">arrow_drop_up</v-icon>
                      <v-icon v-else>arrow_drop_down</v-icon>
                    </a>
                  </div>
                </td>
                <td>{{ $t('Действия') }}</td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(item, i) in bsos" :key="i">
                <td>{{ item.typeName }}</td>
                <td>{{ item.number }}</td>
                <td>{{ new Date(item.makeDate) | dateFormat('DD.MM.YYYY') }}</td>
                <td>{{ item.blankPrice }}</td>
                <td>{{ item.ooptName }}</td>
                <td>{{ item.statusName }}</td>
                <td class="td-sm">
                  <template v-if="item.statusId === madeStatus">
                    <a href="#"
                       @click.prevent.stop="actionMarkAsSpoiled(item.id)">{{ $t('Пометить как испорченный') }}</a>
                    <v-dialog
                      v-model="commentDialog[item.id]"
                      scrollable
                      max-width="600px"
                      :key="'commentDialog_'+item.id"
                    >
                      <v-card class="modal observer-modal">
                        <div class="modal-head">
                          {{ $t('Добавление комментария') }}
                          <v-btn color="modal-close" @click="changeCommentDialog(item.id, false)">
                            <img src="@/assets/img/close-icon.png" alt="icon">
                          </v-btn>
                        </div>
                        <div class="modal-body">
                          <v-row>
                            <v-col cols="4" md="4" class="input-label">
                              <v-label>
                                {{ $t('Комментарий') }}:
                              </v-label>
                            </v-col>
                            <v-col class="input-field">
                              <v-textarea
                                v-model="comment"
                                outlined
                                dense
                                clearable
                              />
                            </v-col>
                          </v-row>
                          <div class="form-action">
                            <button
                              class="btn btn-default blue"
                              type="button"
                              @click="changeByStatus(item.id),  changeCommentDialog(item.id, false)"
                            >
                              {{ $t('Добавить') }}
                            </button>
                            <button
                              class="btn btn-default gray"
                              type="button"
                              @click="changeCommentDialog(item.id, false)"
                            >
                              {{ $t('Отмена') }}
                            </button>
                          </div>
                        </div>
                      </v-card>
                    </v-dialog>
                  </template>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <v-pagination
            v-model="page"
            :length="paginationData.pageCount"
            total-visible="10"
          />
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import Menu from '@/components/bso/Menu'
import Bso from '@/model/bso'

export default {
  components: {
    Menu
  },
  data: () => ({
    page: 1,
    paginationData: {},
    breadcrumbs: [],
    refType: [],
    refStatus: [],
    oopts: [],
    bsos: [],
    sortParams: {
      field: 'date',
      order: 'ASC'
    },
    madeStatus: null,
    spoiledStatus: null,
    currentStatus: null,
    search: {},
    commentDialog: [],
    comment: null
  }),
  watch: {
    page () {
      this.getList(false)
    }
  },
  mounted () {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData () {
      this.setLoading(true)
      Bso.getBsoFilterFormData()
        .then((res) => {
          this.refType = res.data.refBsoType
          this.refStatus = res.data.refBsoStatus
          this.oopts = res.data.oopts
          this.madeStatus = res.data.madeStatus
          this.spoiledStatus = res.data.spoiledStatus
          this.getList()
        })
        .catch((err) => {
          this.setLoading(false)
          console.log(err)
        })
      this.generateBreadcrumbs()
    },
    getList (resetPage = true) {
      this.setLoading(true)
      if (resetPage) this.page = 1
      this.search.page = this.page
      this.search.sortField = this.sortParams.field
      this.search.sortOrder = this.sortParams.order
      Bso.listBso(this.search)
        .then((res) => {
          this.bsos = res.data.items
          this.paginationData = res.data.paginationData
          this.setLoading(false)
        })
        .catch((err) => {
          this.setLoading(false)
          console.log(err)
        })
    },
    sort (field) {
      this.sortParams.field = field
      this.sortParams.order = this.sortParams.order === 'ASC' ? 'DESC' : 'ASC'

      this.getList()
    },
    // Пометить как испорченный
    actionMarkAsSpoiled (id) {
      if (confirm(this.$i18n.t('Вы хотите данный бланк пометить как испорченный?'))) {
        this.changeCommentDialog(id, true)
        this.currentStatus = this.spoiledStatus
      }
    },
    // изменение статуса модального окна для комментариев
    changeCommentDialog (id, flag) {
      this.comment = null
      this.$set(this.commentDialog, id, flag)
    },
    changeByStatus (id) {
      Bso.changeBsoByStatus(id, this.currentStatus, { comment: this.comment })
        .then((response) => {
          const currentBsos = []
          this.bsos.forEach(function (element, index) {
            if (element.id === id) {
              element.statusId = response.data.statusId
              element.statusName = response.data.statusName
            }
            currentBsos.push(element)
          })
          this.bsos = currentBsos
        })
        .catch((error) => {
          this.$noty.warning(this.$i18n.t('Ошибка'), {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
        })
    },
    // генерация хлебных крошек
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Учет БСО'),
          disabled: true
        }
      ]
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.table-overflow {
  table {
    thead {
      td {
        line-height: 1.4;
        vertical-align: middle;
      }
    }
  }
}
</style>
